import { render, staticRenderFns } from "./VocReg.vue?vue&type=template&id=0de9ad5a&scoped=true"
import script from "./VocReg.vue?vue&type=script&lang=js"
export * from "./VocReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de9ad5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de9ad5a')) {
      api.createRecord('0de9ad5a', component.options)
    } else {
      api.reload('0de9ad5a', component.options)
    }
    module.hot.accept("./VocReg.vue?vue&type=template&id=0de9ad5a&scoped=true", function () {
      api.rerender('0de9ad5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/VocReg.vue"
export default component.exports